import { render, staticRenderFns } from "./post-form__section.vue?vue&type=template&id=02619869&lang=pug&"
import script from "./post-form__section.vue?vue&type=script&lang=js&"
export * from "./post-form__section.vue?vue&type=script&lang=js&"
import style0 from "./post-form__section.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports